import { createStore } from "vuex";
import Vue             from "vue";
import axios           from "axios";
import { flatMap }     from "lodash-es";


axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

let state =
        {
            results        : [],
            related        : [],
            appliedFilters : [],
            searchTerms    : "",
            searchType     : "",
            copydeck       : {},
            checked        : [],
            filters        : [],
            favourites     : [],
            loading        : false,


            // default for desktop... mobile acts invertedly
            // (didn't want to refactor "closed" even though
            // it doesn'T mean what it used to anymore)
            filtersOpen : false,
            mobileSize  : '',

        };

let getters =
        {
            shouldFilter ( state )
            {
                return state.checked.length > 0;
            },

            //We remove the hierarchical nature of the filter tree
            flatFilters ( state )
            {
                return ( type = "" ) =>
                {
                    let flat = function ( a, r )
                    {
                        a.push( r );

                        let b = (r.items ?? []).reduce( flat, [] );

                        a = [ ...a, ...b ];

                        return a;
                    };

                    let items = state.filters
                        .filter( f => (type === "") || (f.type === type) )
                        .map( f => f.items )
                        .flat()
                        .reduce( flat, [] );
                    return items;
                }
            },

            filteredResults ( state, getters )
            {
                let results = state.results;

                if ( getters.shouldFilter )
                {

                    let filtersDescriptors = getters.flatFilters( 'descriptor' );
                    let filtersTypes       = getters.flatFilters( 'type' );

                    let checked = state.checked;

                    let checkedDescriptors = checked.map( ch => ch.id );

                    let prevResults                = results.map( resource => resource.id );
                    let resourceThatCanBeDisplayed = [];

                    for ( let i = 0; i < checked.length; i++ )
                    {
                        let check     = checked[ i ];
                        let checkType = check.type;

                        let a                      = filtersDescriptors.find( f => parseInt( f.id ) === parseInt( check.id ) );
                        resourceThatCanBeDisplayed = filtersDescriptors.find( f => parseInt( f.id ) === parseInt( check.id ) )?.resources ?? [];


                        prevResults = resourceThatCanBeDisplayed.filter( id => prevResults.includes( id ) );

                        //results = [...results, ...resourceThatCanBeDisplayed];
                    }

                    results = state.results.filter( resource => prevResults.includes( resource.id ) );

                    if ( false )
                    {

                        // //Get only the ids of the checked filters group by type
                        // let checkedDescriptors = checked.value.filter(ch => ch.type === "descriptor").map(ch => ch.id);
                        // let checkedTypes = checked.value.filter(ch => ch.type === "type").map(ch => ch.id);
                        //
                        // //Get only the resources associated with the checked filters group by type
                        // let resourceThatCanBeDisplayedFromDescriptors = filtersDescriptors.filter(filter => checkedDescriptors.includes(filter.id)).map(filter => filter.resources).flat();
                        // let resourceThatCanBeDisplayedFromType = filtersTypes.filter(filter => checkedTypes.includes(filter.id)).map(filter => filter.resources).flat();
                        //
                        // //Merge resource
                        // let resourceThatCanBeDisplayed = [...resourceThatCanBeDisplayedFromDescriptors, ...resourceThatCanBeDisplayedFromType];
                        // let filteredResults = results.value.filter(resource => resourceThatCanBeDisplayed.includes(resource.id));
                    }

                    //store.commit("filteredResults", filteredResults);

                }

                return results;
            },

            checkedIds ( state )
            {
                return state.checked.map( check => check.id );
            },

            checkedAsTags ( state, getters )
            {
                let checked = getters.checkedIds;

                if ( checked.length === 0 )
                    return [];


                let ff  = getters.flatFilters( "" );
                let ff2 = ff.map( f => ({ id : f.id, title : f.title }) );

                let filters = getters.flatFilters( "" )
                    .map( f => ({ id : f.id, title : f.title }) )
                    .filter( f => checked.includes( f.id ) );


                if ( filters.length === 0 )
                    return [];

                let tags = checked.map( ch => filters.find( f => f.id === ch ) );

                const unique = [ ...new Map( tags.map( item => [ item[ 'id' ], item ] ) ).values() ]

                return unique;
            },


            favouritesResourceId ( state )
            {
                return state.favourites.map( f => f.resources ).flat();
            },


            areFiltersOpen ( state )
            {
                return state.filtersOpen;
            },


            isLoading ( state )
            {
                return state.loading;
            },


            mobileSize ( state )
            {
                return state.mobileSize;
            },

            isMobile ( state )
            {
                return state.mobileSize === 'mobile';
            },
        };


let actions =
        {
            async search ( { commit }, payload )
            {
                let params = "?s=" + payload.searchTerm;

                if ( payload.searchType )
                {
                    params += "&type=" + payload.searchType;
                }

                if ( payload.id )
                {
                    params += "&id=" + payload.id;
                }

                commit( "loading", true );
                let response = await axios.get( "/endpoints/search" + params );

                commit( "results", response.data.results );
                commit( "related", response.data.related );
                commit( "searchTerm", payload.searchTerm );
                commit( "searchTerm", payload.searchTerm );

                commit( "searchType", payload.searchType ?? "" );
                commit( "loading", false );

            },

            async related ( { commit, state } )
            {
                let checked = state.checked;

                let arrIds = checked.map( c => c.id );

                let response = await axios.post( "/endpoints/search/related", {
                    ids  : arrIds,
                    term : state.searchTerms,
                } );

                commit( "related", response.data );
            },
        }


let mutations =
        {
            copydeck ( state, payload )
            {
                state.copydeck = payload;
            },

            results ( state, payload )
            {
                state.results = payload;

                return;

                //we want to link resources to filter
                let fctAddResources = item => item.resources = state.results.filter( resource => resource.taxonomies.filter( taxo => taxo.title === item.title )?.length > 0 ).map( resource => resource.id );
                //let fctAddResources = item => item.resources = state.results.filter.map ( resource => resource.id);

                let filters = state.filters.slice( 1 );
                filters.forEach( filter => (state.filters.find( f => f.title === filter.title )?.items ?? []).forEach( fctAddResources ) );

            },

            related ( state, payload )
            {
                state.related = payload;
            },

            // filteredResults (state, payload)
            // {
            //     state.filteredResults = payload;
            //
            //     //we want to link resources to filter
            //     let fctAddResources = item => item.resources = state.results.filter ( resource => resource.taxonomies.filter( taxo => taxo.title === item.title)?.length > 0).map ( resource => resource.id);
            //
            //     let filters = state.filters.slice(1);
            //     filters.forEach( filter => (state.filters.find(f => f.title === filter.title)?.items ?? []).forEach(fctAddResources) );
            // },

            searchTerm ( state, payload )
            {
                state.searchTerms = payload;
            },

            searchType ( state, payload )
            {
                state.searchType = payload;
            },

            checked ( state, payload )
            {
                if ( payload.checked )
                {
                    state.checked.push( payload );
                } else
                {
                    state.checked = state.checked.filter( ch => payload.id !== ch.id );
                }
            },

            clearSearchType ( state )
            {
                state.searchType = "";
            },


            clearFilters ( state )
            {
                state.checked = [];

            },


            filters ( state, payload )
            {
                state.filters = payload;
            },

            favourites ( state, payload )
            {
                state.favourites = payload;
            },

            clearSearch ( state )
            {
                state.searchTerms = "";
                state.searchType  = "";
            },

            loading ( state, payload )
            {
                state.loading = payload;
            },

            filtersOpen ( state, payload )
            {
                state.filtersOpen = payload;
            },

            toggleFiltersVisibility ( state )
            {

                state.filtersOpen = !state.filtersOpen;
                console.log( 'toggleFiltersVisibility... now=', state.filtersOpen )

                if ( state.mobileSize === 'mobile' && state.filtersOpen )
                {
                    const openFiltersToggleBtn = document.querySelector( '.filters-toggle-btn:not(.filter-toggle-mobile)' );
                    if ( openFiltersToggleBtn )
                    {
                        openFiltersToggleBtn.focus();
                    }
                } else if ( state.mobileSize === 'mobile' && !state.filtersOpen )
                {
                    const openFiltersToggleBtn = document.querySelector( '.filter-toggle-mobile' );
                    if ( openFiltersToggleBtn )
                    {
                        openFiltersToggleBtn.focus();
                    }
                }
            },

            openFilters ( state )
            {
                state.filtersOpen = true;
            },
            closeFilters ( state )
            {
                state.filtersOpen = false;
            },

            detectSize ( state )
            {

                const prevMode = state.mobileSize;

                state.mobileSize = window.innerWidth < 1200 ? 'mobile' : 'desktop';

/*console.log(( 'detectSize', prevMode, state.mobileSize ))*/;
                // let's just reset the show/hide of the filters when switching modes
                if ( prevMode !== state.mobileSize )
                {
                    if ( 'mobile' === state.mobileSize )
                    {
                        state.filtersOpen = false;

                        const btnFiltersToggle = document.querySelector( '.filter-toggle-mobile' );
                        if ( btnFiltersToggle )
                        {
                            btnFiltersToggle.focus();
                        }
                    } else
                    {
                        state.filtersOpen = true;
                    }
                }
            },
        }


export default createStore( { state, getters, actions, mutations } );

